import axios from "axios";

/**
 * Function to login
 * @param {Object} { commit } - Vuex function
 * @param {Object} payload - User email and password
 */
export async function login({ commit }, payload) {
  try {
    const { data } = await axios.post(`/login`, payload);

    if (!data.user) {
      throw data;
    }
    if (
      data.user.role != "ORG_USER_ADMIN" &&
      data.user.role != "ORG_USER" &&
      data.user.role != "SELLER" &&
      data.user.role != "ADMIN_SAMPLER" &&
      data.user.role != "SAMPLER_SOLENA" &&
      data.user.role != "GEN_MANAGER" &&
      data.user.role != "MANAGER" &&
      data.user.role != "ADVISOR"
    ) {
      throw data;
    }
    commit("SET_LOGIN_DATA_PROFILE", data);

    // let user = {
    //   userId: data.user._id,
    //   name: data.user.name,
    //   lastName: data.user.lastName,
    //   email: data.user.email,
    //   role: data.user.role,
    //   phone: data.user.phone,
    //   address:{
    //     street: data.user.address.street,
    //     interiorNumber: data.user.address.interiorNumber,
    //     exteriorNumber: data.user.address.exteriorNumber,
    //     suburb: data.user.address.suburb,
    //     zipCode: data.user.address.zipCode,
    //     city: data.user.address.city,
    //     state: data.user.address.state
    //   }
    // };
    // localStorage.setItem("token", data.user.token);
    // localStorage.setItem(
    //   "organizationId",
    //   data.user.commercialOrganizationId
    //     ? data.user.commercialOrganizationId
    //     : ""
    // );
    // localStorage.setItem("user", JSON.stringify(user));
    // sessionStorage.setItem("authenticated", true);
    // commit("SET_TOKEN", data.user.token);
    // commit("SET_USER_DATA", user);
    // commit("areasList/SET_SOIL_AREAS", data.user.soilAreas, { root: true });
    return data;
  } catch (e) {
    console.log(e);
    return e.response.data;
  }
}

/**
 * Function to get new token
 * @param {Object} { commit } - Vuex function
 * @param {String} payload - User id
 */
export async function getNewToken({ commit }, payload) {
  try {
    const { data } = await axios.post(`/refresh-token`, { user: payload });
    if (data.error) throw data;
    commit("SET_TOKEN", data.token);
    localStorage.setItem("token", data.token);
    sessionStorage.setItem("authenticated", true);
    return data;
  } catch (e) {
    return e;
  }
}

/**
 * Function to logout a user
 * @param {Object} { commit } - Vuex function
 */
export async function logout({ commit }) {
  try {
    await axios.get(`/logout/${localStorage.getItem("tokenFirebase")}`);
    localStorage.removeItem("tokenFirebase");
    commit("SET_LOG_OUT");
  } catch (e) {
    return e;
  }
}

export async function sendRestartPassword({ commit }, email) {
  try {
    const { data } = await axios.post(`/user/generate-reset-token`, {
      email: email,
    });
    return data;
  } catch (e) {
    return e;
  }
}

export function changeLanguage({ commit }, language) {
  commit("SET_LANGUAGE", language);
}
